<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <va-button-group>
          <va-button flat outline disabled>数据来源:</va-button>
          <va-button flat outline disabled color="red">{{ insertData.isCrawler }}</va-button>
          <va-button flat outline disabled color="info" :href="insertData.link" target="_blank"
            v-if="disableLink">LinkedIn岗位链接</va-button>
          <va-button flat outline disabled color="info" :href="insertData.organizationJobLink" target="_blank"
            v-if="disableLink && insertData.organizationJobLink">公司官网岗位链接</va-button>
        </va-button-group>
        <div class="row">
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='insertData.id' v-show="showId" label='id' disabled />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='insertData.referralId' v-show="showReferralId" label='唯一标识' disabled />
          </div>
          <!--          <div class='flex md4 sm6 xs12'>-->
          <!--            <va-input v-model='insertData.views' v-show="showViews" label='投递岗位人数' disabled />-->
          <!--          </div>-->
          <div class="flex md6 sm6 xs12">
            <va-select label="公司名称" v-model="insertData.organizationName" :options="computedOrganizations" searchable
              :messages="message" :error="!!error.organizationErrors.length" :error-messages="error.organizationErrors" />
          </div>
          <!--          <div class="flex md6 sm6 xs12">-->
          <!--            <va-select label="篱笆合作企业" v-model="insertData.isOfficial" :options="isOfficialOptions" :messages="message"-->
          <!--              :error="!!error.isOfficialErrors.length" :error-messages="error.isOfficialErrors" />-->
          <!--          </div>-->
          <div class='flex md12 sm6 xs12' v-show="insertData.organizationName.length !== 0">
            <va-card overlay :image='flipLogos[insertData.organizationName]' class="va-card-image">
            </va-card>
          </div>
          <!--          <div class="flex md12 sm6 xs12"><va-button flat disabled-->
          <!--              color="gray">备注：岗位标签用于岗位列表页面的筛选，课程标签用于为拥有相同课程标签的课程推荐职位</va-button></div>-->
          <!-- <div class="flex md6 sm6 xs12">
            <va-select label="岗位标签" v-model="insertData.referralTagIds" multiple :options="computedReferralTags" />
          </div> -->
          <div class="flex md12 sm6 xs12">
            <va-select label="课程标签(用于课程推荐系统)" v-model="insertData.courseTagIds" multiple :options="computedCourseTags" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.position" label="职位" removable :messages="message"
              :error="!!error.positionErrors.length" :error-messages="error.positionErrors" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.location" label="工作地点" removable :messages="message"
              :error="!!error.locationErrors.length" :error-messages="error.locationErrors" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select v-model="insertData.type" label="全职/实习" :options="typeOptions" :messages="message"
              :error="!!error.typeErrors.length" :error-messages="error.typeErrors" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select label="国家代码" v-model="insertData.countryCode" :options="countryCodeOptions"
              :messages="message" :error="!!error.countryCodeErrors.length" :error-messages="error.countryCodeErrors" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.coordinates" label="经纬度坐标" placeholder="例: [37.3861, -122.0839]" removable />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.crawlerAuthor" label="爬取人（员工姓名/工号）" removable
              :disabled="insertData.isCrawler === '后台添加'" />
          </div>
          <!--          <div class="flex md12 sm6 xs12">-->
          <!--            <va-input type="textarea" v-model="insertData.companyInfo" label="公司介绍" removable rows="15"-->
          <!--              :messages="message" :error="!!error.companyInfoErrors.length" :error-messages="error.companyInfoErrors" />-->
          <!--          </div>-->
          <!--          <div class="flex md12 sm6 xs12">-->
          <!--            <va-input type="textarea" v-model="insertData.responsibility" label="工作职责" removable rows="15"-->
          <!--              :messages="message" :error="!!error.responsibilityErrors.length"-->
          <!--              :error-messages="error.responsibilityErrors" />-->
          <!--          </div>-->
          <!--          <va-button outline flat disabled>岗位要求</va-button>-->
          <!--          <div class="flex md12 sm6 xs12">-->
          <!--            <vue-trix v-model="insertData.jobRequirement" placeholder="岗位要求" :messages="message"-->
          <!--              :error="!!error.jobRequirementErrors.length" :error-messages="error.jobRequirementErrors"></vue-trix>-->
          <!--          </div>-->
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.link"
              label="岗位链接"
              :disabled="disableLink"
            />
          </div>
          <!--                    <div class="flex md12 sm6 xs12">-->
          <!--                      <va-input-->
          <!--                        v-model="insertData.link"-->
          <!--                        label="公司官网岗位链接"-->
          <!--                        :disabled="disableLink"-->
          <!--                      />-->
          <!--                    </div>-->
          <div class="flex md4 sm6 xs12">
            <va-select label="状态" v-model="insertData.status" :options="statusOptions" :messages="message"
              :error="!!error.statusErrors.length" :error-messages="error.statusErrors" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.sortNum" label="排序" placeholder="数字越大越靠前" removable
              oninput="if(value <0)value=1" :min="1" :messages="message" :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors" />
          </div>
          <div class='flex md4 sm6 xs12' v-show="showCreatedAt">
            <va-input v-model='insertData.createTime' label='创建时间' disabled />
          </div>
          <div class='flex md4 sm6 xs12' v-show="showCreatedAt">
            <va-input v-model='insertData.releaseTime' label='岗位发布时间' disabled />
          </div>
        </div>

        <!-- 数据源信息 -->
        <va-divider>
          <span style="color: #154ec1; font-weight: bold;">数据源信息</span>
        </va-divider>
        <div class="row" v-show="showDataSource">
          <div class="flex md6 sm6 xs12">
            <va-input v-model="insertData.dataSource.name" label="数据源名称" disabled />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input v-model="insertData.dataSource.siteUrl" label="数据源URL" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.siteCategoryText" label="网站分类" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.atsPlatformName" label="ATS平台名称" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.createdBy" label="爬虫项目名称" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.crawlStatusText" label="爬取状态" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.lastSuccessTimeText" label="最后成功时间" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="insertData.dataSource.failureReasonText" label="失败原因" disabled />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input v-model="insertData.dataSource.description" label="描述信息" disabled />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input v-model="insertData.dataSource.tags" label="标签" disabled />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input v-model="insertData.dataSource.failureMessage" label="失败详细信息" disabled />
          </div>
        </div>

        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import referralApi from '../../api/referral'
import { copyObject, formatTime } from '@/utils/common'
import tagApi from '../../api/tag'
import { DATASOURCE, TAG_TYPES } from '../../utils/constants'
import organizationApi from '@/api/organization'

export default {
  data () {
    return {
      insertData: {
        id: null,
        uid: '',
        referralId: '',
        organizationName: '',
        logo: '',
        position: '',
        location: '',
        views: null,
        companyInfo: '',
        jobRequirement: '',
        responsibility: '',
        status: '已发布',
        sortNum: 1,
        isOfficial: null,
        referralTagIds: [],
        courseTagIds: [],
        createTime: '',
        link: '',
        organizationJobLink: '',
        isCrawler: '后台添加',
        type: '',
        releaseTime: '',
        countryCode: 'US',
        coordinates: '',
        crawlerAuthor: '',
        dataSource: {
          id: null,
          name: '',
          siteUrl: '',
          siteCategory: null,
          siteCategoryText: '',
          description: '',
          tags: '',
          organizationId: null,
          organizationName: '',
          atsPlatformName: '',
          createdBy: '',
          crawlStatus: null,
          crawlStatusText: '',
          lastSuccessTime: null,
          lastSuccessTimeText: '',
          failureReason: null,
          failureReasonText: '',
          failureMessage: '',
          createTime: null,
          updateTime: null,
        },
      },
      placeholders: {
        name: '例: ',
        position: '例: ',
        location: '例: ',
        companyInfo: '例: ',
        jobRequirement: '例: ',
        responsibility: '例: ',
      },
      message: ['Required field'],
      referralTags: [],
      courseTags: [],
      organizations: [],
      error: {
        organizationErrors: [],
        positionErrors: [],
        locationErrors: [],
        companyInfoErrors: [],
        jobRequirementErrors: [],
        responsibilityErrors: [],
        sortNumErrors: [],
        statusErrors: [],
        isOfficialErrors: [],
        typeErrors: [],
        countryCodeErrors: [],
      },
      showId: false,
      showReferralId: false,
      showCreatedAt: false,
      showViews: false,
      showDataSource: false,
      disableLink: false,
      title: '新增岗位',
      statusOptions: ['草稿中', '已发布', '已下架'],
      isOfficialOptions: ['是', '否'],
      typeOptions: ['未分类', '实习', '全职'],
      countryCodeOptions: ['US', 'CN', 'SG', 'CA', 'AU', 'IE', 'UK', 'IN'],
      submitButtonStatus: true,
      referralTagTypeName: '岗位标签',
      courseTagTypeName: '课程标签',
    }
  },
  created () {
    this.getReferral()
    // this.listReferralTag()
    this.listCourseTag()
    this.listOrganization()
  },
  computed: {
    computedReferralTags () {
      return this.referralTags.map(x => {
        return x.name
      })
    },
    computedCourseTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    computedOrganizations () {
      return this.organizations.map(x => {
        return x.name
      })
    },
    formReady () {
      return !this.error.organizationErrors.length &&
        !this.error.locationErrors.length &&
        !this.error.positionErrors.length &&
        !this.error.companyInfoErrors.length &&
        !this.error.responsibilityErrors.length &&
        !this.error.jobRequirementErrors.length &&
        !this.error.sortNumErrors.length &&
        !this.error.statusErrors.length &&
        !this.error.isOfficialErrors.length &&
        !this.error.typeErrors.length
    },
    flipReferralTags () {
      const flipReferralTags = {}
      this.referralTags.forEach(x => {
        flipReferralTags[x.name] = x.id
      })
      return flipReferralTags
    },
    flipCourseTags () {
      const flipCourseTags = {}
      this.courseTags.forEach(x => {
        flipCourseTags[x.name] = x.id
      })
      return flipCourseTags
    },
    flipOrganizations () {
      const flipOrganizations = {}
      this.organizations.forEach(x => {
        flipOrganizations[x.name] = x.id
      })
      return flipOrganizations
    },
    flipLogos () {
      const flipLogos = {}
      this.organizations.forEach(x => {
        flipLogos[x.name] = x.logo
      })
      return flipLogos
    },
  },
  methods: {
    getReferral () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.showReferralId = true
        this.showViews = true
        this.showCreatedAt = true
        this.title = '编辑岗位'
        // 通过id获取详情
        referralApi.getReferral(params.id).then(response => {
          copyObject(response.referral, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.referral.hasOwnProperty('referralId')) {
            this.insertData.referralId = response.referral.referralId
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.referral.hasOwnProperty('type')) {
            if (response.referral.type === 0) {
              this.insertData.type = '未分类'
            } else if (response.referral.type === 1) {
              this.insertData.type = '实习'
            } else {
              this.insertData.type = '全职'
            }
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.referral.hasOwnProperty('status')) {
            if (response.referral.status === 0) {
              this.insertData.status = '草稿中'
            } else if (response.referral.status === 1) {
              this.insertData.status = '已发布'
            } else {
              this.insertData.status = '已下架'
            }
          }
          // eslint-disable-next-line no-prototype-builtins
          if (!response.referral.hasOwnProperty('isOfficial') || response.referral.isOfficial === false) {
            this.insertData.isOfficial = '否'
          } else {
            this.insertData.isOfficial = '是'
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('referralTags') && response.referralTags.length !== 0) {
            const that = this
            that.insertData.referralTagIds = []
            response.referralTags.forEach(x => {
              that.insertData.referralTagIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
            const that = this
            that.insertData.courseTagIds = []
            response.courseTags.forEach(x => {
              that.insertData.courseTagIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('organization')) {
            const that = this
            that.insertData.organizationName = response.organization.name
            that.insertData.logo = response.organization.logo
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.referral.hasOwnProperty('isCrawler')) {
            const that = this
            DATASOURCE.forEach(x => {
              if (x.CODE === response.referral.isCrawler) {
                that.insertData.isCrawler = x.TEXT
                if (x.CODE === 1) {
                  this.disableLink = true
                }
              }
            })
          }
          // 处理新增字段
          if (response.referral.hasOwnProperty('countryCode')) {
            this.insertData.countryCode = response.referral.countryCode || 'US'
          }
          if (response.referral.hasOwnProperty('coordinates')) {
            this.insertData.coordinates = response.referral.coordinates || ''
          }
          if (response.referral.hasOwnProperty('crawlerAuthor')) {
            this.insertData.crawlerAuthor = response.referral.crawlerAuthor || ''
          }
          // 处理数据源信息
          if (response.referral.hasOwnProperty('dataSource') && response.referral.dataSource) {
            this.showDataSource = true
            const ds = response.referral.dataSource
            this.insertData.dataSource.id = ds.id || null
            this.insertData.dataSource.name = ds.name || ''
            this.insertData.dataSource.siteUrl = ds.siteUrl || ''
            this.insertData.dataSource.siteCategory = ds.siteCategory !== undefined && ds.siteCategory !== null ? ds.siteCategory : null
            // 网站分类文本
            const categoryMap = { 0: '未分类', 1: 'ATS系统', 2: '公司招聘页', 3: '聚合网站' }
            this.insertData.dataSource.siteCategoryText = categoryMap[ds.siteCategory] !== undefined ? categoryMap[ds.siteCategory] : '未知'
            this.insertData.dataSource.description = ds.description || ''
            this.insertData.dataSource.tags = ds.tags || ''
            this.insertData.dataSource.organizationId = ds.organizationId || null
            this.insertData.dataSource.organizationName = ds.organizationName || ''
            this.insertData.dataSource.atsPlatformName = ds.atsPlatformName || ''
            this.insertData.dataSource.createdBy = ds.createdBy || ''
            this.insertData.dataSource.crawlStatus = ds.crawlStatus !== undefined && ds.crawlStatus !== null ? ds.crawlStatus : null
            // 爬取状态文本
            const statusMap = { 0: '未爬取', 10: '已调度', 20: '爬取中', 30: '解析中', 1: '成功', 2: '本轮无岗位', 3: '失败' }
            this.insertData.dataSource.crawlStatusText = statusMap[ds.crawlStatus] !== undefined ? statusMap[ds.crawlStatus] : '未知'
            this.insertData.dataSource.lastSuccessTime = ds.lastSuccessTime || null
            // 处理秒级时间戳
            const lastSuccessTimestamp = ds.lastSuccessTime && ds.lastSuccessTime.toString().length === 10 ? ds.lastSuccessTime * 1000 : ds.lastSuccessTime
            this.insertData.dataSource.lastSuccessTimeText = lastSuccessTimestamp ? new Date(lastSuccessTimestamp).toLocaleString('zh-CN') : '无'
            this.insertData.dataSource.failureReason = ds.failureReason !== undefined && ds.failureReason !== null ? ds.failureReason : null
            // 失败原因文本
            const failureMap = { 0: '无', 1: '反爬', 2: '人机验证', 3: '需要登录', 4: '其他', 5: '数据源无岗位', 6: '限流(429)' }
            this.insertData.dataSource.failureReasonText = failureMap[ds.failureReason] !== undefined ? failureMap[ds.failureReason] : '未知'
            this.insertData.dataSource.failureMessage = ds.failureMessage || ''
            this.insertData.dataSource.createTime = ds.createTime || null
            this.insertData.dataSource.updateTime = ds.updateTime || null
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    // listReferralTag() {
    //   let tagType = null
    //   TAG_TYPES.forEach(x => {
    //     if (x.TEXT === this.referralTagTypeName) {
    //       tagType = x.CODE
    //     }
    //   })
    //   tagApi.listTag({ tagType: tagType }).then(response => {
    //     this.referralTags = response.tags
    //     console.log("listReferralTag", response.tags)
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // },
    listCourseTag () {
      let tagType = null
      TAG_TYPES.forEach(x => {
        if (x.TEXT === this.courseTagTypeName) {
          tagType = x.CODE
        }
      })
      tagApi.listTag({ tagType: tagType }).then(response => {
        this.courseTags = response.tags
        console.log('listCourseTag', response.tags)
      }).catch(error => {
        console.log(error)
      })
    },
    listOrganization () {
      organizationApi.listOrganization().then(response => {
        this.organizations = response.organizations
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        uid: this.insertData.uid,
        //  views: this.insertData.views,
        position: this.insertData.position,
        location: this.insertData.location,
        //  companyInfo: this.insertData.companyInfo,
        //  responsibility: this.insertData.responsibility,
        //  jobRequirement: this.insertData.jobRequirement,
        link: this.insertData.link,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
        // referralTagIds: this.insertData.referralTagIds.map(tagName => {
        //   return this.flipReferralTags[tagName]
        // }),
        courseTagIds: this.insertData.courseTagIds.map(tagName => {
          return this.flipCourseTags[tagName]
        }),
        organizationId: this.flipOrganizations[this.insertData.organizationName],
        countryCode: this.insertData.countryCode,
        coordinates: this.insertData.coordinates,
        crawlerAuthor: this.insertData.crawlerAuthor,
      }
      data.isOfficial = !(this.insertData.isOfficial === null || this.insertData.isOfficial === '否')
      if (this.insertData.status === null || this.insertData.status === '草稿中') {
        data.status = 0
      } else if (this.insertData.status === '已发布') {
        data.status = 1
      } else {
        data.status = 2
      }
      if (this.insertData.type === '' || this.insertData.type === '未分类') {
        data.type = 0
      } else if (this.insertData.type === '实习') {
        data.type = 1
      } else {
        data.type = 2
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        DATASOURCE.forEach(x => {
          if (x.TEXT === this.insertData.isCrawler) {
            data.isCrawler = x.CODE
          }
        })
        referralApi.updateReferral(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新岗位成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listReferral' })
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
        })
      } else {
        data.isCrawler = 0
        referralApi.saveReferral(data).then(response => {
          if (response.success === true) {
            this.showToast('保存岗位成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listReferral' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.organizationErrors = this.insertData.organizationName ? [] : ['organization is required']
      this.error.locationErrors = this.insertData.location ? [] : ['location is required']
      this.error.positionErrors = this.insertData.position ? [] : ['position is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
      //   this.error.isOfficialErrors = this.insertData.isOfficial ? [] : ['isOfficial is required']
      //   this.error.companyInfoErrors = this.insertData.companyInfo ? [] : ['companyInfo is required']
      //    this.error.responsibilityErrors = this.insertData.responsibility ? [] : ['responsibility is required']
      //  this.error.jobRequirementErrors = this.insertData.jobRequirement ? [] : ['jobRequirement is required']
      this.error.typeErrors = this.insertData.type ? [] : ['type is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
